import { render, staticRenderFns } from "./SpecialSubject.vue?vue&type=template&id=31cc2b42&scoped=true&"
import script from "./SpecialSubject.vue?vue&type=script&lang=ts&"
export * from "./SpecialSubject.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialSubject.vue?vue&type=style&index=0&id=31cc2b42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cc2b42",
  null
  
)

export default component.exports